export const cutString = ( stringToCut: string, maxLen: number ): string => {
  // If the string is too long it will be cut to the max length.
  if(stringToCut.length > maxLen) {
    const trimmedString = stringToCut.substr(0, (maxLen));
    stringToCut = trimmedString + '...';
  }
  return stringToCut;
}
